module.exports = __webpack_public_path__ + "img/wangshuai.3c813d61.jpg";